import type { IdentifiedUser } from '@onefootprint/request-types';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const getDisplayPhone = ({
  user,
  phoneNumber,
}: {
  user?: IdentifiedUser;
  phoneNumber?: string;
}): string | undefined => {
  const isLoginChallenge = !!user;
  if (isLoginChallenge && !user.matchingFps?.includes('id.phone_number')) {
    // The user was identified via something other the phone that was passed in, so we don't know
    // that the phoneNumber we have is the one on the vault. Instead, we'll use the scrubbed one
    // that belongs to the user
    return (
      user?.scrubbedPhone
        ?.replace(/\*/g, '•')
        // Replace spaces with non-breaking spaces and hyphens with non-breaking hyphens
        .replace(/ /g, '\u00A0')
        .replace(/-/g, '\u2011')
    );
  }
  // Either we located the user with this phone number, or we're initiating a signup challenge to
  // this phone number
  const parsed = phoneNumber ? parsePhoneNumberFromString(phoneNumber) : undefined;
  const formatted = parsed ? `+${parsed.countryCallingCode} ${parsed.formatNational()}` : phoneNumber;
  // Replace spaces with non-breaking spaces and hyphens with non-breaking hyphens
  return formatted?.replace(/ /g, '\u00A0').replace(/-/g, '\u2011');
};

export const getDisplayEmail = ({ user, email }: { user?: IdentifiedUser; email?: string }): string | undefined => {
  const isLoginChallenge = !!user;

  if (isLoginChallenge && !user.matchingFps?.includes('id.email')) {
    // The user was identified via something other the email that was passed in, so we don't know
    // that the email we have is the one on the vault. Instead, we'll use the scrubbed email if
    // available
    return user?.scrubbedEmail?.replace(/\*/g, '•');
  }
  // Either we located the user with this email, or we're initiating a signup challenge to this email
  return email;
};
